package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun ComprehendLanguagesMetadata() {
    SpellMetadata(
        spellIndex = "comprehend-languages",
        castingTime = "1 action",
        range = "Self",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A pinch of soot and salt.",
        duration = "1 hour",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
